import { render } from "./REACTION_ADDED_TO_COMMENT.vue?vue&type=template&id=23c5a11c&ts=true"
import script from "./REACTION_ADDED_TO_COMMENT.vue?vue&type=script&lang=ts"
export * from "./REACTION_ADDED_TO_COMMENT.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__